import { OrganizationKeyName } from "../../../model/Organization";
import { RootState } from "../../../store";

import * as authSelectors from "../../auth/authSelectors";
import { UserVoucherListItem } from "../model/GetUserVoucherListSuccessResponse";

const emptyList: UserVoucherListItem[] = [];
Object.freeze(emptyList);

export const userVoucherList = (
  state: RootState,
  userId: string | number,
  org?: OrganizationKeyName
) => {
  if (!org) {
    org = authSelectors.selectedOrganizationKeyName(state);
  }

  return state.shop.org[org]?.userVoucherList[userId] || emptyList;
};

export const isLoadingUserVoucherList = (
  state: RootState,
  userId: string | number,
  org?: OrganizationKeyName
) => {
  if (!org) {
    org = authSelectors.selectedOrganizationKeyName(state);
  }

  return state.shop.org[org]?.userVoucherListIsLoading[userId];
};

export const userVoucher = (
  state: RootState,
  id: string | undefined,
  org?: OrganizationKeyName
) => {
  if (!id) {
    return;
  }

  if (!org) {
    org = authSelectors.selectedOrganizationKeyName(state);
  }

  return state.shop.org[org]?.userVoucher?.[id];
};

export const isLoadingUserVoucher = (
  state: RootState,
  id?: string,
  org?: OrganizationKeyName
) => {
  if (!id) {
    return false;
  }

  if (!org) {
    org = authSelectors.selectedOrganizationKeyName(state);
  }

  return !!state.shop.org[org]?.userVoucherIsLoading[id];
};

export const upsertUserVoucherErrors = (
  state: RootState,
  id?: string,
  org?: OrganizationKeyName
) => {
  if (!org) {
    org = authSelectors.selectedOrganizationKeyName(state);
  }

  return state.shop.org[org]?.upsertUserVoucherErrors[id || "__new"];
};
